import(/* webpackMode: "eager" */ "/codebuild/output/src902701299/src/pubgen-app/next-app/app/global-error.tsx");
